import { render, staticRenderFns } from "./CapturaDocumentosAssinatura.vue?vue&type=template&id=5eeaa04c&scoped=true&"
import script from "./CapturaDocumentosAssinatura.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentosAssinatura.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentosAssinatura.vue?vue&type=style&index=0&id=5eeaa04c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eeaa04c",
  null
  
)

export default component.exports